import { Pipe, PipeTransform } from '@angular/core';
import { MemberAccount } from '../../../models/transactions/member-account';
import { AccountTypeIdEnum } from '../../../models/enum/shared/account-type-id.enum';

@Pipe({ name: 'accountDisplayName', standalone: true })
export class AccountDisplayNamePipe implements PipeTransform {
  transform(account: MemberAccount, includeType = true): string {
    switch (account.typeId) {
      case AccountTypeIdEnum.VariableBenefit: {
        const typeSuffix = includeType ? ` ${account.type?.name ?? ''}` : '';
        return account.governingJurisdictionId
          ? `${account.governingJurisdiction?.name ?? ''}${typeSuffix}`
          : $localize`Non-Locked-In` + typeSuffix;
      }
      case AccountTypeIdEnum.MonthlyPension: {
        const details = account.monthlyPensionAccountDetails;
        return $localize`${details?.annuityType?.name ?? ''} – ${details?.annuityGuaranteePeriod?.name ?? ''}`;
      }
      default:
        return account.employer;
    }
  }
}
